var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.brandHeader)?_c('div',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(this.brandHeader)}}):(_vm.isLonewolf)?_c('lonewolf-header'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }